<script>
	export let title = "Le catalogue demandé n'existe pas ou n'est plus disponible."
</script>

<style lang="scss">
    @import "./styles/variables.scss";
    #not-found {
        background-color: white;
        width: 70%;
        position: absolute !important;
        transform: translateX(-50%) translateY(-50%);
        top: 50%;
        left: 50%;
        text-align: center;
        z-index: 999;
        h1 {
            margin:auto;
            font-weight: bold;
            color: $orange;
            font-size: 2em;
        }
    }
</style>

<div id="not-found" class="p-5">
    <h1>{title}</h1>
</div>
